



































































































































import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import * as firebase from "firebase/app";
import moment from "moment";
import AWS from "aws-sdk";
import uuid from "uuid";
import path from "path";
import LocationSearchModal from "@/components/LocationSearchModal.vue";
import Map from "@/components/Map.vue";
import { API_BASE_URL, S3_BUCKET, AWS_CREDENTIALS, COLOUR_OPTIONS, DATE } from "@/shared/global-values";
import ILocation from "@/types/location";

export default Vue.extend({
  components: {
    LocationSearchModal,
    Map,
  },
  data() {
    return {
      colour: "RED",
      colourOptions: COLOUR_OPTIONS,
      location: {} as ILocation,
      dateOptions: DATE,
      addedPhoto: false,
      isDisabled: false,
    };
  },
  computed: {
    isLocationSearchVisible(): boolean {
      return this.$store.getters.getIsLocationSearchVisible;
    },
  },
  mounted() {
    const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
    const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
    const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;

    const today: Date = new Date();

    dateDay.value = today.getDate().toString();
    dateMonth.value = DATE.MONTHS[today.getMonth()];
    dateYear.value = today.getFullYear().toString();
  },
  methods: {
    toggleLocationSearch() {
      this.$store.dispatch("toggleLocationSearch");
    },
    isSelectedColour(colour: string): boolean {
      return colour === this.colour;
    },
    selectColour(event: Event): void {
      const span: HTMLSpanElement = event.currentTarget as HTMLSpanElement;
      this.colour = span.dataset.colour as string;
    },
    selectLocation(location: ILocation): void {
      this.location = location;
    },
    previewPhoto(event: Event): void {
      const input: HTMLInputElement = event.currentTarget as HTMLInputElement;
      const files: FileList | null = input.files;

      if (files) {
        const photo: File = files[0];
        this.addedPhoto = true;

        const fileReader: FileReader = new FileReader();
        fileReader.onload = (event: Event) => {
          const photoPreview: HTMLImageElement = this.$refs.photoPreview as HTMLImageElement;
          photoPreview.setAttribute("src", fileReader.result as string);
        };
        fileReader.readAsDataURL(photo);
      }
    },
    clearLocation(): void {
      this.location.name = "";
    },
    clearPhoto(): void {
      const input: HTMLInputElement = document.getElementById("photo") as HTMLInputElement;
      input.value = "";
      this.addedPhoto = false;

      const photoPreview: HTMLImageElement = this.$refs.photoPreview as HTMLImageElement;
      photoPreview.removeAttribute("src");
    },
    async create(event: Event): Promise<void> {
      this.isDisabled = true;

      const dateDay: HTMLSelectElement = this.$refs.dateDay as HTMLSelectElement;
      const dateMonth: HTMLSelectElement = this.$refs.dateMonth as HTMLSelectElement;
      const dateYear: HTMLSelectElement = this.$refs.dateYear as HTMLSelectElement;
      const dateString: string = `${dateDay.value}-${dateMonth.value}-${dateYear.value}`;

      const form: HTMLFormElement = event.currentTarget as HTMLFormElement;
      const formData: FormData = new FormData(form);
      formData.set("date", moment(dateString, "D-MMMM-YYYY").toISOString());

      if (this.location.name && this.location.name !== "") {
        formData.set("location_name", this.location.name);
        formData.set("location_address", this.location.address);
        formData.set("latitude", this.location.latitude as unknown as string);
        formData.set("longitude", this.location.longitude  as unknown as string);
      }

      try {
        const fileInput: HTMLInputElement = document.getElementById("photo") as HTMLInputElement;
        if (fileInput.files!.length > 0) {
          const photo: File = formData.get("photo") as File;
          const objectKey = `${uuid.v4()}${path.extname(photo.name)}`;
          const S3: AWS.S3 = new AWS.S3({ accessKeyId: AWS_CREDENTIALS.ACCESS_KEY_ID, secretAccessKey: AWS_CREDENTIALS.SECRET_ACCESS_KEY });
          await S3.putObject({ Bucket: S3_BUCKET, Key: objectKey, Body: photo, ACL: "public-read" }).promise();

          formData.delete("photo");
          formData.set("photo_url", `https://${S3_BUCKET}.s3.amazonaws.com/${objectKey}`);
        }

        const token: string = await firebase.auth().currentUser!.getIdToken();
        const response: AxiosResponse = await axios.post(`${API_BASE_URL}/expenses`, formData, { withCredentials: true, headers: { Authorization: `Bearer ${token}` } });
        this.$router.push({ name: "Expense", params: { id: response.data.id } });

      } catch (error) {
        console.error(error);
      }
    },
  },
});
